import { render, staticRenderFns } from "./creatives.vue?vue&type=template&id=3536cb38&scoped=true"
import script from "./creatives.vue?vue&type=script&lang=js"
export * from "./creatives.vue?vue&type=script&lang=js"
import style0 from "./creatives.vue?vue&type=style&index=0&id=3536cb38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3536cb38",
  null
  
)

export default component.exports